// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled('div', {
  width: '100%',
  userSelect: 'none',
  overflow: 'auto',
})

export const Header = styled('div', {
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontWeight: 500,
  padding: '5px 0',
  fontSize: '18px',
})

export const NavigateButton = styled<{
  $hidden?: boolean,
}>('div', ({ $hidden, $palette }) => ({
  padding: '10px 10px',
  cursor: 'pointer',
  color: `${$palette('primary')}`,
  opacity: $hidden ? 0 : 1,
  pointerEvents: $hidden ? 'none' : 'inherit',
  transition: 'all 430ms cubic-bezier(0.165, 0.84, 0.44, 1)',
  borderRadius: '50px',
  ':hover': {
    backgroundColor: `${$palette('primary').lighten(40)}`,
  },
}))
